/*
 *安装依赖swiper： npm install swiper -S
 *value:array，数组中的每个对象具有thumb和full字段，分别为缩略图和大图
 *initialIndex：初始化的index
 *loop:boolean，是否开启循环查看模式
 */
<template>
    <div class="swiper-container image-preview">
		<i class="el-icon-error" @click="close"></i>
		<div class="tip">
			双击图片放大查看
		</div>
    <div class="swiper-wrapper">
        <div v-if="typeof(value)==='string'"  class="swiper-slide">
              <div class="swiper-zoom-container">
                <img :src="value"  class="swiper-lazy"/><!--swiper-no-swiping-->
                <!-- <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div> -->
            </div>
        </div>
        <div v-else class="swiper-slide" v-for="(item, index) in value" :key="index">
            <div class="swiper-zoom-container">
                <img :src="item"  class="swiper-lazy"/><!--swiper-no-swiping-->
                <!-- <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div> -->
            </div>
        </div>
    </div>
    <!-- 如果需要分页器 -->
    <div class="swiper-pagination"></div>
    <!-- 如果需要导航按钮 -->
    <div style="color:white">{{initialIndex}}</div>
    <template v-if="value&&typeof(value)!=='string'&&value.length>1">
         <div class="swiper-button-prev  swiper-button-white"></div>
    <div class="swiper-button-next  swiper-button-white"></div>
        <!-- <div v-if="initialIndex" class="swiper-button swiper-button-prev swiper-button-white"></div>
        <div class="swiper-button swiper-button-next swiper-button-white"></div> -->
    </template>
	</div>
</template>
<script type="text/javascript">
import Swiper from 'swiper/dist/js/swiper.js'
require('swiper/dist/css/swiper.css')
export default {
  name: 'wt-image-preview',
  props: {
    value: {
      type: [Array, String]
    },
    initialIndex: {
      type: Number,
      default: 0
    },
    loop: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mySwiper: null
    }
  },
  methods: {
    close () {
      this.$emit('close-preview')
    }
  },
  mounted () {
    this.mySwiper = new Swiper('.swiper-container', {
      direction: 'horizontal',
      loop: this.loop,
      initialSlide: this.initialIndex,
      // 如果需要分页器
      pagination: '.swiper-pagination',
      zoom: true,
      mousewheelControl: true,
      lazyLoading: true,
      noSwiping: true,
      onProgress: function (swiper) {
        /* 在图片放大或缩小时进行切换时，先将其缩放状态重置 */
        if (swiper.zoom.currentScale !== 1) {
          swiper.zoom.toggleZoom(swiper)
        }
      },
      navigation: {
        // 如果需要前进后退按钮
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
        // nextEl: typeof (this.value) !== 'string' && this.value.length > 1 && this.initialIndex < this.value.length - 1 ? '.swiper-button-next' : '',
        // prevEl: typeof (this.value) !== 'string' && this.value.length > 1 && this.initialIndex > 0 ? '.swiper-button-prev' : ''
      }
    })
  }
}
</script>
<style lang="less">
	.swiper-container{
		position:fixed!important;
		top:0;
		bottom:0;
		left:0;
		width:100%;
		color:#000000;
		background-color:#000;
		z-index:100!important;
		.tip{
			position:absolute;
			top:6%;
			width:100%;
			color:#fefefe;
			text-align: center;
		}
		.swiper-wrapper{
			width:100%;
            height:100%;
            display: flex;
            justify-content: flex-start;
            .swiper-slide{
                width:90%
            }
			.swiper-zoom-container{
                padding:30px 0;
                box-sizing:border-box
			}
		}
        .el-icon-error{
            position: absolute;
            z-index: 500;
            top:20px;
            right: 20px;
            color:red;
            font-size: 20px
        }
	}
	.swiper-pagination-bullet{
		background-color:#fff!important;
	}
	@media screen and (max-width:1280px){
		.swiper-container .tip{
			display:none;
		}
	}
</style>
